import { CampaignType, CampaignTypeDirect, CampaignTypeHouse } from '~/src/dash/api/console-api';

export const CAMPAIGN_TYPES = [
  {
    label: 'Direct',
    value: CampaignTypeDirect,
  },
  {
    label: 'House',
    value: CampaignTypeHouse,
  },
];

export const getCampaignTextByType = (val: CampaignType): string => {
  const typ = CAMPAIGN_TYPES.find((type) => {
    return type.value === val;
  });

  if (typ) {
    return typ.label;
  }
  return '';
};
